import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {TabNavigation, LoadingSpinner} from '@albert-io/atomic';
import {Link, withRouter} from 'react-router';
import useMandarkQueries from 'lib/hooks/useMandarkQueries';

import PendingApproval from './Staff/PendingApproval.react';
import PendingInvitations from './Staff/PendingInvitations.react';
import Approved from './Staff/Approved.react';
import Rejected from './Staff/Rejected.react';
import './manage-staff.scss';
import {
  getApprovedStaff,
  getPendingApprovedStaff,
  getRejectedStaff,
  getPendingInviteCount
} from './Staff/manageStaffUtils';

const manageStaffTabs = {
  pendingApproval: 'pending-approval',
  pendingInvitations: 'pending-invitations',
  approved: 'approved',
  rejected: 'rejected'
};

const ManageStaff = ({params, routes}) => {
  const activeUrlRoute = routes[routes.length - 1].path;
  const [activeTab, setActiveTab] = useState(
    Object.values(manageStaffTabs).includes(activeUrlRoute)
      ? activeUrlRoute
      : manageStaffTabs.pendingApproval
  );

  // Using a useMandarkQueries hook to make sure these queries resolve before the page loads
  const {isReady, _resources} = useMandarkQueries([
    getPendingApprovedStaff(params.schoolId),
    getApprovedStaff(params.schoolId),
    getRejectedStaff(params.schoolId)
  ]);

  if (!isReady) {
    return <LoadingSpinner className='u-mar-tb_4' size={2} />;
  }

  const getResourceTotalEntries = (resource) => {
    return resource.getResourceMetadata().getIn(['page', 'total_entries']);
  };

  const pendingApprovedStaffTotal = getResourceTotalEntries(
    getPendingApprovedStaff(params.schoolId)
  );
  const approvedStaffTotal = getResourceTotalEntries(getApprovedStaff(params.schoolId));
  const rejectedStaffTotal = getResourceTotalEntries(getRejectedStaff(params.schoolId));

  const getActiveTable = () => {
    if (activeTab === manageStaffTabs.pendingApproval) return <PendingApproval params={params} />;
    if (activeTab === manageStaffTabs.pendingInvitations)
      return <PendingInvitations params={params} />;
    if (activeTab === manageStaffTabs.approved) return <Approved params={params} />;
    return <Rejected params={params} />;
  };

  return (
    <div className='manage-staff u-pad_4'>
      <TabNavigation paddingLevel={0} align='left'>
        <TabNavigation.Tab
          as={Link}
          to={`/school-admin/${params.schoolId}/manage-staff/pending-approval`}
          isActive={activeTab === 'pending-approval'}
          onClick={() => setActiveTab('pending-approval')}
        >
          Pending Approval ({pendingApprovedStaffTotal})
        </TabNavigation.Tab>
        <TabNavigation.Tab
          as={Link}
          to={`/school-admin/${params.schoolId}/manage-staff/pending-invitations`}
          isActive={activeTab === 'pending-invitations'}
          onClick={() => setActiveTab('pending-invitations')}
        >
          Pending Invitations ({getPendingInviteCount(params.schoolId)})
        </TabNavigation.Tab>
        <TabNavigation.Tab
          as={Link}
          to={`/school-admin/${params.schoolId}/manage-staff/approved`}
          isActive={activeTab === 'approved'}
          onClick={() => setActiveTab('approved')}
        >
          Approved ({approvedStaffTotal})
        </TabNavigation.Tab>
        <TabNavigation.Tab
          as={Link}
          to={`/school-admin/${params.schoolId}/manage-staff/rejected`}
          isActive={activeTab === 'rejected'}
          onClick={() => setActiveTab('rejected')}
        >
          Rejected ({rejectedStaffTotal})
        </TabNavigation.Tab>
      </TabNavigation>
      {getActiveTable()}
    </div>
  );
};

ManageStaff.propTypes = {
  params: PropTypes.object,
  routes: PropTypes.array
};

export default withRouter(ManageStaff);
